import { render, staticRenderFns } from "./newsletterH.vue?vue&type=template&id=08bb2767"
import script from "./newsletterH.vue?vue&type=script&lang=js"
export * from "./newsletterH.vue?vue&type=script&lang=js"
import style0 from "./newsletterH.vue?vue&type=style&index=0&id=08bb2767&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports